import { inject, Injectable, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  getCurrentEditUserRoleSelector,
  getPermissionsSelector,
  getRolesSelector,
  GroupByRolesType,
  GroupedPermissions,
  groupPermissions,
  groupRolesByRoleType,
  Role,
  ROLES_ACTION,
  RPermissions,
  UserRole,
} from '@data-access/roles';
import { distinctUntilChanged, filter, map } from 'rxjs';
import { isEqual } from 'lodash';

@Injectable()
export class RolesFacadeService {
  private readonly _store = inject(Store);

  /**
   * @Selectors
   * */
  roles = toSignal(
    this._store.select(getRolesSelector).pipe(
      filter(Boolean),
      map((r) => groupRolesByRoleType(r.data)),
    ),
  ) as Signal<GroupByRolesType>;

  permissions = toSignal(
    this._store.select(getPermissionsSelector).pipe(
      filter(Boolean),
      map((permissions) =>
        groupPermissions(permissions as unknown as RPermissions),
      ),
    ),
  ) as Signal<GroupedPermissions[]>;

  currentEditUserRole = toSignal(
    this._store.select(getCurrentEditUserRoleSelector).pipe(
      distinctUntilChanged((a, b) => isEqual(a, b)),
      filter(Boolean),
      map((r) => r),
    ),
  ) as Signal<Role>;

  /**
   * @Dispatchers
   * */
  createEditUserRole(role: UserRole, editMode: boolean, roleId = ''): void {
    if (editMode && roleId.length > 0) {
      this._store.dispatch(
        ROLES_ACTION.updateUserRole({
          roleId: roleId,
          role: role,
        }),
      );
    } else {
      this._store.dispatch(
        ROLES_ACTION.creatUserRole({
          role: role,
        }),
      );
    }
  }

  clearCurrentUserRole() {
    this._store.dispatch(ROLES_ACTION.clearCurrentUserRole());
  }
}
